import { apiSlice } from "./apiSlice";

export const usersSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Get all user list
        getUserList: builder.query({
            query: (params) => ({
                url: `Account/list`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllUsers"],
        }),

        // Get user detail by ID
        getUserDetail: builder.query({
            query: (id) => ({
                url: `Account/${id}`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllUsers"],
        }),

        // Create new user
        createUser: builder.mutation({
            query: ({ body }) => ({
                url: `Account/create`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["AllUsers"],
        }),

        // Update user
        updateUser: builder.mutation({
            query: ({ body }) => ({
                url: `Account/update`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["AllUsers"],
        }),

        // Delete user
        deleteUser: builder.mutation({
            query: (id) => ({
                url: `Account/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ["AllUsers"],
        }),

    })
})

export const { useGetUserListQuery, useLazyGetUserListQuery, useGetUserDetailQuery, useCreateUserMutation, useUpdateUserMutation, useDeleteUserMutation } = usersSlice;
